// SPDX-License-Identifier: Apache-2.0
import type { IBrainSerializable } from '../state/brain/decorators';
import DrawingFeature, { DrawingShape } from './drawingFeature';

export default class DrawingState implements IBrainSerializable {
  public isBrainSerializable = true;
  public activeTool: DrawingShape | null = null;
  public tools: { shape: DrawingShape | null; enabled?: boolean }[] = [];
  public features: DrawingFeature[] = [];
}
